'use client';

import { useSystemLabels } from '@eliadmin/core/src/hooks/use-system-labels';
import Link from '@eliadmin/core/src/components/link';

import { CartBadge } from '@eliadmin/core/src/components/header/cart-badge';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { HEADER_CONFIG } from '@eliadmin/core/src/constants/header-config';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCartQueryOpts } from '@eliadmin/core/src/hooks/cart/use-cart';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useQuery } from '@tanstack/react-query';
import { MdOutlineShoppingBag } from 'react-icons/md';

export type HeaderCartButtonProps = {
  className?: {
    root?: string;
    info?: string;
    title?: string;
    price?: string;
    badge?: string;
  };
};

export function HeaderCartButton({ className }: HeaderCartButtonProps) {
  const systemLabels = useSystemLabels();
  const { data: cart } = useQuery({ ...useCartQueryOpts() });

  return (
    <Link aria-label={systemLabels('cart')} href={ROUTES.CART() ?? '#'} prefetch={false}>
      <Button
        asChild
        variant={'secondary'}
        size={'icon'}
        className={cn('w-fit text-center',
          'ea-cart-button', className?.root)}
      >
        <div data-ea-visual-tag="button">
          <div className="relative flex h-5 w-5 items-center">
            {<MdOutlineShoppingBag size={24} />}

            <CartBadge
              className={cn('h-5 w-4 bg-primary', className?.badge)}
              variant={HEADER_CONFIG.headerMain.cart.badgeVariant}
            />
          </div>
        </div>
      </Button>
    </Link>
  );
}
